module.exports = __webpack_public_path__ + "img/DE00658.782df271.png";